import round from 'lodash/round';

import { Skeleton, Typography, Stack } from '@cast/design-system';
import { ComputeResourceType } from '@cast/shared-types';

import { useIsLoading } from 'core/loading';

import { MetricRow } from '../_components/MetricRow';
import { ResourceUsageMetrics } from '../types';

const naming = {
  [ComputeResourceType.CPU]: { acronym: 'CPU', full: 'CPU' },
  [ComputeResourceType.MEMORY]: { acronym: 'GiB', full: 'MEMORY' },
};

type Props = {
  metrics: ResourceUsageMetrics;
  type: ComputeResourceType.CPU | ComputeResourceType.MEMORY;
  testId?: string;
};

export const NodeMetricsSection = ({ metrics, type, testId }: Props) => {
  const isLoading = useIsLoading();
  const { acronym, full } = naming[type];

  return (
    <Stack data-testid={testId}>
      <Stack direction="row" justifyContent="space-between" mb={16}>
        <Typography variant="L12B">{full}</Typography>

        {!isLoading && (
          <Typography variant="P14B">
            {`${metrics.capacity} ${acronym}`}
          </Typography>
        )}
      </Stack>

      {!isLoading ? (
        <Stack gap={8}>
          <MetricRow
            label="Reqs."
            progressValue={metrics.usage}
            progressColor="blue.200"
            tooltipTitle={`Requested ${acronym} out of Allocatable ${acronym}`}
            primaryValue={`${metrics.requested} ${acronym}`}
            secondaryValue={` ${round(metrics.usage)} %`}
          />
        </Stack>
      ) : (
        <Skeleton width="100%" />
      )}
    </Stack>
  );
};
